import React, {Component} from 'react';
import { isEmpty, isEqual } from '../../../../../shared/services/lodashInJS.js';
import Plus from 'react-feather/dist/icons/plus.js';
import Edit from 'react-feather/dist/icons/edit.js';
import Trash from 'react-feather/dist/icons/trash.js';
import nl2br from 'react-nl2br';
import { parseISO, isAfter } from 'date-fns';
import {Link} from 'react-router-dom';

import handleResponseErrors from '../../../../services/processServerErrors.js';
import DiplomeModal from '../../../../components/Modals/Diplome/DiplomeModal.jsx';
import DeleteDiplomeModal from '../../../../components/Modals/Diplome/DeleteDiplomeModal.jsx';
import CertificationForm from '../../../../components/Forms/CertificationForm/CertificationForm.jsx';
import Date from '../../../../../shared/components/Moment/Date.jsx';
import Loader from '../../../../../shared/components/Loader/Loader.jsx';

import {generate} from '../../../../routes.js';
import connectModal from '../../../../../shared/components/Modals/connect.js';

import './Parcours.scss';
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

export class Parcours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      degrees: this.sortChronologically(this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : []),
      certifications: this.sortChronologically(this.props.freelance?.certifications?.length ? this.props.freelance.certifications : [])
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevDegrees = prevProps.freelance?.diplomes?.length ? prevProps.freelance.diplomes : [];
    const degrees = this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : [];
    if (!isEqual(prevDegrees, degrees)) {
      this.setState({
        degrees: this.sortChronologically(degrees)
      })
    }
    const prevCertifications = prevProps.freelance?.certifications?.length ? prevProps.freelance.certifications : [];
    const certifications = this.props.freelance?.certifications?.length ? this.props.freelance.certifications : [];
    if (!isEqual(prevCertifications, certifications)) {
      this.setState({
        certifications: this.sortChronologically(certifications)
      })
    }
  }

  sortChronologically = (degrees) => {
    return degrees
      .sort((a, b) => {
        const dateA = parseISO(a.year);
        const dateB = parseISO(b.year);
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1;
          } else {
            return 1;
          }
        } else {
          return 0;
        }
      });
  }

  createNewDiplome = () => {
    this.props.openDiplomeModal({
      freelance: this.props.freelance,
      onSubmit: this.props.submit,
    });
  };

  editExistingDiplome = (offset) => {
    return () => {
      this.props.openDiplomeModal({
        freelance: this.props.freelance,
        onSubmit: this.props.submit,
        onClose: this.onClose,
        offset
      });
    }
  };

  deleteDiplome = (offset) => {
    return () => {
      this.props.openDeleteDiplomeModal({
        freelance: this.props.freelance,
        offset
      });
    };
  };

  onClose = (degrees) => {
    this.setState({degrees: this.sortChronologically(degrees)});
  }

  save = async () => {
    this.setState({loading: true});
    try {
      await this.props.submit({
        user: this.props.user,
        freelance: this.props.freelaance,
      });
    } catch (e) {
      console.warn(e);
    } finally {
      this.setState({loading: false});
      this.props.onFormSuccess();
    }
  };

  addElementTo = (field) => {
    return (values) => {
      const newValues = [...(this.props.freelance?.[field] ?? [])];
      newValues.push(values);

      return this.props.submit({
        freelance: {
          [field]: newValues
        },
      }).catch(handleResponseErrors);
    }
  };

  removeElementFrom = (field, offset) => {
    return async () => {
      this.setState({deleting: true});
      const newValues = [...(this.props.freelance?.[field] ?? [])];
      newValues.splice(offset, 1);

      try {
        await this.props.submit({
          freelance: {
            [field]: newValues
          }
        });
      } catch (e) {
        console.warn(e);
      } finally {
        this.setState({deleting: false});
      }
    }
  };

  render() {
    const hasDegrees = !isEmpty(this.state.degrees);

    return (
      <FreelancePage className="step-parcours p-5">
        <div>
          <h2 className="text-center">Formation</h2>
          <p className="text-center mb-5">
            Complétez ici votre parcours de formation, diplômes et certifications
          </p>
          {!hasDegrees
            ? <div className="callout callout-secondary text-center col-md-7 mx-auto">
              <p>
                Afin de finaliser votre profil et être plus attractif auprès des recruteurs
                veuillez saisir vos diplômes / formations.
              </p>
              <button type="button" onClick={this.createNewDiplome} className="btn btn-outline-primary">
                <Plus/> Ajouter un diplôme / formation
              </button>
            </div>
            : <div>
              <p className="text-right">
                <button type="button" onClick={this.createNewDiplome} className="btn btn-outline-primary">
                  <Plus/> Ajouter un diplôme / formation
                </button>
              </p>
              {this.state.degrees.map((diplome, offset) => (
                <div className="callout callout-parcours" key={offset}>
                  <div className="controls">
                    <div onClick={this.editExistingDiplome(offset)}
                      className="btn btn btn-outline-primary btn-round btn-sm">
                      <Edit/>
                    </div>
                    <div onClick={this.deleteDiplome(offset)} className="btn btn btn-outline-danger btn-round btn-sm">
                      <Trash/>
                    </div>
                  </div>
                  {(diplome.name || diplome.year) &&
                  <div>
                    {diplome.name && <b>{diplome.name}</b>}
                    {diplome.name && diplome.year && <span> - </span>}
                    {diplome.year && <Date format="yyyy" date={diplome.year}/>}
                  </div>
                  }
                  <div className={(diplome.name) ? 'mt-2' : ''}>
                    {nl2br(diplome.description)}
                  </div>
                </div>
              ))}
            </div>
          }

          <div className="text-center mt-5 mb-4">
            <h4>Certifications</h4>
          </div>
          <CertificationForm onSubmit={this.addElementTo('certifications')}/>
          <div className="certifications">
            {this.state.certifications.map((certification, index) => (
              <div key={certification.id} className="callout d-inline-block mr-3 mt-0 mb-3">
                <b>{certification.label}</b>
                {certification.date && <span> - <Date format="yyyy" date={certification.date}/></span>}
                <button
                  onClick={this.removeElementFrom('certifications', index)}
                  type="button"
                  className="btn btn-round btn-sm btn-outline-danger ml-3"
                >
                  <Trash/>
                </button>
              </div>
            ))}
          </div>

          {!this.props.edit &&
          <div className="mt-5 d-flex flex-wrap align-items-center">
            <div className="mr-auto">
              <Link to={generate({name: 'homepage'})} className="gray">
                Je finirai plus tard (ne pas sauvegarder)
              </Link>
            </div>
            {hasDegrees &&
            <button onClick={this.save} type="button" className="btn btn-primary ml-auto">Étape suivante</button>
            }
          </div>}
        </div>
        <Loader visible={this.state.loading}>
          Sauvegarde en cours...
        </Loader>
      </FreelancePage>
    );
  }
}

export default connectModal({DiplomeModal, DeleteDiplomeModal}, Parcours);